// components
import { Navbar1 } from 'components/navbars';
import BackToTop from 'components/BackToTop';
import { Footer1 } from 'components/footer';

import Hero from './Hero';

// dummy data
//import { plans, benefits } from './data';

const PrivacyPolicy = () => {
    return (
        <>
            <div>
                <Navbar1
                    hideSearch
                    fixedWidth
                    navClass="navbar-light zindex-10"
                    buttonClass="btn-outline-secondary btn-sm"
                />
                <Hero />
            </div>
            <div className="m-auto" style={{display:"block",width: "80%",maxWidth:1200,paddingTop:20}}>
                <p><strong>Last Updated: July 24, 2024</strong></p>

                <h2>1. Introduction</h2>

                <p>Welcome to Sitepost, an application developed and operated by Pixel Framers LLC ("we," "us," or "our"). This Privacy Policy is designed to inform you about how we collect, use, and protect your personal information when you use our Sitepost application ("App"). We are committed to safeguarding your privacy and ensuring the security of your personal data.</p>

                <h2>2. Information We Collect</h2>

                <p>When you use Sitepost, we collect the following information:</p>

                <ul>
                    <li>Business Name</li>
                    <li>Email Address</li>
                    <li>Business Address</li>
                </ul>

                <h2>3. How We Use Your Information</h2>

                <p>We use the information we collect for the following purposes:</p>

                <ul>
                    <li>To provide and maintain the App's functionality</li>
                    <li>To improve and optimize the App's performance</li>
                    <li>To communicate with you about App updates and new features</li>
                    <li>To inform you about related apps developed by Pixel Framers LLC</li>
                    <li>To comply with legal obligations</li>
                </ul>

                <h2>4. Data Storage and Security</h2>

                <p>We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. Your data is stored on secure servers and is only accessible to authorized personnel who require access to perform their duties.</p>

                <h2>5. Data Retention</h2>

                <p>We will retain your personal information for as long as necessary to fulfill the purposes outlined in this Privacy Policy, unless a longer retention period is required or permitted by law.</p>

                <h2>6. Sharing Your Information</h2>

                <p>We do not sell, trade, or rent your personal information to third parties. We may share your information with trusted service providers who assist us in operating the App, conducting our business, or servicing you, as long as they agree to keep this information confidential.</p>

                <h2>7. Your Rights</h2>

                <p>You have the right to:</p>

                <ul>
                    <li>Access the personal information we hold about you</li>
                    <li>Request correction of any inaccurate information</li>
                    <li>Request deletion of your personal information</li>
                    <li>Object to the processing of your personal information</li>
                    <li>Request the transfer of your personal information</li>
                </ul>

                <p>To exercise these rights, please contact us using the information provided in Section 11.</p>

                <h2>8. Changes to This Privacy Policy</h2>

                <p>We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date at the top of this policy.</p>

                <h2>9. Minor's Privacy</h2>

                <p>Sitepost is not intended for use by minors under the age of 18. We do not knowingly collect personal information from minors under 18. If you are a parent or guardian and believe that your child has provided us with personal information, please contact us immediately.</p>

                <h2>10. Third-Party Links</h2>

                <p>Sitepost may contain links to third-party websites or services. We are not responsible for the privacy practices or content of these third-party sites. We encourage you to read the privacy policies of any third-party sites you visit.</p>
                <h2>11. Contact Us</h2>

                <p>If you have any questions, concerns, or requests regarding this Privacy Policy or our data practices, please contact us at:</p>

                <p>
                    Pixel Framers LLC<br />
                    2220 Landmark Place, Mansquan, NJ<br />
                    support@pixelframers.com<br />
                    646-413-6354
                </p>

                <h2>12. Consent</h2>

                <p>By using Sitepost, you consent to the collection and use of your information as described in this Privacy Policy. If you do not agree with the terms of this policy, please do not use the App.</p>
            </div>
            {/* footer */}
            <Footer1 />

            <BackToTop />
        </>
    );
};

export default PrivacyPolicy;
